import React from "react";
import { RouteObject } from "react-router-dom";
import { getModuleRoutes } from "./modules/module.register";

// Import modules to ensure they are registered first
import "./modules/auth/auth.module";
import "./modules/main/main.module";
import "./modules/pos/pos.module";
import "./modules/business-admin/business-admin.module";
import "./modules/super-admin/super-admin.module";
import "./modules/subscription/subscription.module.tsx";
import "./modules/accounting/accounting.module";

// Now get the routes after modules are registered
const moduleRoutes = getModuleRoutes();

// Combine main routes with module routes
const allRoutes: RouteObject[] = [...moduleRoutes];

export const routes = allRoutes;
